import * as React from 'react';
import cn from 'clsx';

import { IWithDeviceTypeProps, withDeviceType } from '../../utils/withDeviceType';

import * as styles from './styles.css';

/**
 * Список с вырезами в секции "Лёгкий путь к сделке за 3 шага".
 */
const DealStepsList: React.FC<React.PropsWithChildren<IWithDeviceTypeProps>> = props => {
  return <ol className={cn(styles['list'], styles[props.deviceType])}>{props.children}</ol>;
};

const DealStepsListWithDeviceType = withDeviceType(DealStepsList);
export { DealStepsListWithDeviceType as DealStepsList };
